import httpRequest from "utils/httpRequest";
const URL = "/api";

export const getLibraryList = async (e_line, cur_page,groupId) => {
  const requestBody = {
    e_line,
    cur_page,
    menu: "L:"+groupId,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/selectManualList`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getLibrary = async (no) => {
  const requestBody = {
    no,
 //   file_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/selectManual`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const insertLibraryInfo = async (e,groupId) => {
  const formData = new FormData();

  let usedScope = 'L';
  if (e.used_scope === '2'){
    usedScope = 'L:'+groupId;
  }

  formData.append("title", e.title);
 // formData.append("menu", "L");
  formData.append("menu", usedScope);
  formData.append("file", e.file);
  try {
    const response = await httpRequest(
      "post",
      `${URL}/insertManualInfo`,
      formData
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateLibraryInfo = async (e,groupId) => {
  const formData = new FormData();

  let usedScope = 'L';
  if (e.used_scope === '2'){
    usedScope = 'L:'+groupId;
  }
  formData.append("menu", usedScope);
  formData.append("file_id", e.file_id);
  formData.append("title", e.title);
  formData.append("no", e.no);

  try {
    const response = await httpRequest(
      "post",
      `${URL}/updateManualInfo`,
      formData
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const deleteLibraryInfo = async (no) => {
  const requestBody = {
    no,
 //   file_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/deleteManualInfo`,
      requestBody
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const download = async (e) => {
  const download_link = e.download_link;
  const file_name = e.file_name;

  try {
    const response = await fetch("/api/download", {
      method: "POST",
      body: JSON.stringify({
        download_link,
        file_name,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const blob = await response.blob(); // 바이너리 데이터를 blob 객체로 변환
    const link = document.createElement("a");

    link.href = window.URL.createObjectURL(blob);
    link.download = file_name;

    link.click();
  } catch (error) {
    console.error(error);
  }
};
